import React from "react";

function RightSideLayout3() {
  return <React.Fragment>{/* <QuickPanel /> */}</React.Fragment>;
}

export default RightSideLayout3;
